import {
  CAMPAIGN_ANALYSIS_FAILURE_REASON,
  CAMPAIGN_ANALYSIS_STATUS,
  CAMPAIGN_ANALYSIS_TARGET_METRIC,
  CAMPAIGN_ITEM_TYPE,
  CAMPAIGN_LABEL,
  CAMPAIGN_STATUS,
} from './generated/campaign-constants';

export const CAMPAIGN_LABEL_TYPE = CAMPAIGN_LABEL;
export type CAMPAIGN_LABEL_TYPE = CAMPAIGN_LABEL;

export const EMPTY_LABEL_VALUE = 'No-label' as const;
export const ALL_LABELS_VALUE = '__all_labels__';

export const CampaignLabelOptions = [
  {
    value: EMPTY_LABEL_VALUE,
    label: 'No label',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.AFFILIATE,
    label: 'Affiliate',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.GIFTING,
    label: 'Gifting',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.CASH_PAID,
    label: 'Paid',
  },
];

export const CampaignLabelFilterOptions = [
  {
    value: ALL_LABELS_VALUE,
    label: 'All labels',
  },
  ...CampaignLabelOptions,
];

export const CampaignStatus = CAMPAIGN_STATUS;
export type CampaignStatus = CAMPAIGN_STATUS;

export const CampaignAnalysisStatus = CAMPAIGN_ANALYSIS_STATUS;
export type CampaignAnalysisStatus = CAMPAIGN_ANALYSIS_STATUS;

export const CampaignAnalysisFailureReason = CAMPAIGN_ANALYSIS_FAILURE_REASON;
export type CampaignAnalysisFailureReason = CAMPAIGN_ANALYSIS_FAILURE_REASON;

export const CampaignAnalysisTargetMetric = CAMPAIGN_ANALYSIS_TARGET_METRIC;
export type CampaignAnalysisTargetMetric = CAMPAIGN_ANALYSIS_TARGET_METRIC;

export const CampaignTrackingItemType = CAMPAIGN_ITEM_TYPE;
export type CampaignTrackingItemType = CAMPAIGN_ITEM_TYPE;
